import {autoRegister, resolve} from "../../../container";
import {promiseFromJsonResponse} from "../../../common/utils/promises";
import {RequestSugarFactory} from "../../common/requestSugar";
import {SecuredRequestExecutor} from "../../../module/awswaf/securedRequestExecutor";

export type ActionResponse = {
    success: boolean;
};

@autoRegister()
export class ActionService {
    private missionOneConfirmUrl: string;
    private missionOneUnsubscribeUrl: string;
    private cyberSecurityConfirmUrl: string;
    private cyberSecurityUnsubscribeUrl: string;

    public constructor(private securedRequestExecutor: SecuredRequestExecutor = resolve(SecuredRequestExecutor)) {
        this.missionOneConfirmUrl = "/enbw-eop/eop-app-form/rest/stable/action/missionone/confirm/";
        this.missionOneUnsubscribeUrl = "/enbw-eop/eop-app-form/rest/stable/action/missionone/unsubscribe/";
        this.cyberSecurityConfirmUrl = "/enbw-eop/eop-app-form/rest/stable/action/cybersecurity/confirm/";
        this.cyberSecurityUnsubscribeUrl = "/enbw-eop/eop-app-form/rest/stable/action/cybersecurity/unsubscribe/";
    }

    public async confirmMissionOneSubscriber(request: MissionOneMidRequest): Promise<ActionResponse> {
        const postRequest = (): Promise<Response> => fetch(`${this.missionOneConfirmUrl}${request.getMid()}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "EOP-Sugar": RequestSugarFactory.produce()
            },
            body: JSON.stringify({mid: request.getMid()})
        });
        const response = await this.securedRequestExecutor.execute(postRequest);
        return promiseFromJsonResponse(response);
    }

    public async deleteMissionOneSubscriber(request: MissionOneMidRequest): Promise<ActionResponse> {
        const postRequest = (): Promise<Response> => fetch(`${this.missionOneUnsubscribeUrl}${request.getMid()}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "EOP-Sugar": RequestSugarFactory.produce()
            },
            body: JSON.stringify({mid: request.getMid()})
        });
        const response = await this.securedRequestExecutor.execute(postRequest);
        return promiseFromJsonResponse(response);
    }

    public async confirmCyberSecuritySubscriber(request: CyberSecurityOptInIDRequest): Promise<ActionResponse> {
        const postRequest = (): Promise<Response> => fetch(`${this.cyberSecurityConfirmUrl}${request.getOptInId()}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "EOP-Sugar": RequestSugarFactory.produce()
            },
            body: JSON.stringify({optInId: request.getOptInId()})
        });
        const response = await this.securedRequestExecutor.execute(postRequest);
        return promiseFromJsonResponse(response);
    }

    public async unsubscribeCyberSecuritySubscriber(request: CyberSecurityOptInIDRequest): Promise<ActionResponse> {
        const postRequest = (): Promise<Response> => fetch(`${this.cyberSecurityUnsubscribeUrl}${request.getOptInId()}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "EOP-Sugar": RequestSugarFactory.produce()
            },
            body: JSON.stringify({optInId: request.getOptInId()})
        });
        const response = await this.securedRequestExecutor.execute(postRequest);
        return promiseFromJsonResponse(response);
    }
}


export class MissionOneMidRequest {
    public constructor(private mid: string) {
    }

    public getMid(): string {
        return this.mid;
    }
}

export class CyberSecurityOptInIDRequest {
    public constructor(private optInId: string) {
    }

    public getOptInId(): string {
        return this.optInId;
    }
}